import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import html2canvas from "html2canvas";
import { Button } from "primereact/button";
import { ToggleButton } from "primereact/togglebutton";
import { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import { useReactToPrint } from "react-to-print";
import NoInfo from "../../components/NoInfo";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import NumberUtil from "../../utility/NumberUtil";
import { getChartDataByCaseSn } from "../../utility/service/dashboard-service";
import { checkDpSuccess, getCompanyType } from "../../utility/service/tool-service";
import ChartSkeleton from "./ChartSkeleton";
import CusDountChart from "./CusDountChart";
import CusGaugeChart from "./CusGaugeChart";

export const DashboardMain = ({ isPlanSn = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchDialog, setSearchDialog] = useState(false);
  const [searchCon, setSearchCon] = useState({});
  const location = useLocation();
  const [greenhouseGasList, setGreenhouseGasList] = useState([]);
  const [emission, setEmission] = useState();
  const [, loading] = useContext(SystemLoading);
  //type 為 A
  const [allFactoryGas, setAllFactoryGas] = useState([]);
  const [allFactoryGasData, setAllFactoryGasData] = useState([]);

  //type 為 B
  const [gasEmissions, setGasEmissions] = useState([]);
  const [gasEmissionsData, setGasEmissionsData] = useState([]);
  const [emissionsData, setEmissionsData] = useState([]);
  const [emissionsDataDetail, setEmissionsDataDetail] = useState([]);
  //統計圖表切換
  const [emissionChecked, setEmissionChecked] = useState(true);
  const [emissionGasChecked, setEmissionGasChecked] = useState(true);
  const [factoryGasChecked, setFactoryGasChecked] = useState(true);

  const [ratingResults, setRatingResults] = useState(null);
  const [oopsShow, setOopsShow] = useState(true);
  const [expanded, setExpanded] = useState(false);

  const { itemObj } = useOutletContext();

  // 列印排放量計算頁面
  const contentRef = useRef(null);
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const chartRef3 = useRef(null);
  const chartRef4 = useRef(null);

  // 設置標記，表示從子頁面返回
  useEffect(() => {
    sessionStorage.setItem("fromCarbonChildPage", "true");
  }, []);

  const {
    register,
    handleSubmit,
    resetField,
    reset,
    watch,
    clearErrors,
    getValues,
    setValue,
    control,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      year: "",
      placeName: "",
      caseSn: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  const gasData = [
    { name: "CO2", emissions: "co2", percent: "co2Percent" },
    { name: "CH4", emissions: "ch4", percent: "ch4Percent" },
    { name: "N2O", emissions: "n2o", percent: "n2oPercent" },
    { name: "HFCs", emissions: "hfcs", percent: "hfcsPercent" },
    { name: "PFCs", emissions: "pfcs", percent: "pfcsPercent" },
    { name: "SF6", emissions: "sf6", percent: "sf6Percent" },
    { name: "NF3", emissions: "nf3", percent: "nf3Percent" },
    { name: t("bioEmissionEquivalent"), emission: "co2BioEnergy", percent: "" },
  ];

  const EmptyEmission = () => {
    return (
      <>
        <div className="dashboard-table">
          {/* 第一個區塊 年度總排放量 */}
          <div className="header">{t("totalAnnualEmissions")}</div>
          <div className="header"></div>
          <div className="header">%</div>
          {/* 範疇1 */}
          <div className="col font-bold">{t("category_no", { no: 1 })}</div>
          <div className="col"></div>
          <div className="col">%</div>
          {/* 範疇2 */}
          <div className="col font-bold">{t("category_no", { no: 2 })}</div>
          <div className="col"></div>
          <div className="col">%</div>
          {/* 範疇3 目前沒資料 */}
          <div className="col font-bold">{t("category_no", { no: 3 })}</div>
          <div className="col"></div>
          <div className="col">%</div>
        </div>

        {/* 第二個區塊 範疇1 */}
        <div className="dashboard-table">
          <div className="header">{t("category_no", { no: 1 })}</div>
          <div className="header"></div>
          <div className="header">%</div>
          <div className="col font-bold">{t("fixedEmissions")}</div>
          <div className="col"></div>
          <div className="col">%</div>
          <div className="col font-bold">{t("processEmissions")}</div>
          <div className="col"></div>
          <div className="col">%</div>
          <div className="col font-bold">{t("mobileEmissions")}</div>
          <div className="col"></div>
          <div className="col">%</div>
          <div className="col font-bold">{t("fugitiveEmissions")}</div>
          <div className="col"></div>
          <div className="col">%</div>
        </div>

        {/* 第三個區塊 範疇2 */}
        <div className="dashboard-table">
          <div className="header">{t("category_no", { no: 2 })}</div>
          <div className="header">{NumberUtil.formatWithCommas(emission?.energyIndirectEmissions)}</div>
          <div className="header">{NumberUtil.formatWithCommas(emission?.energyIndirectEmissionsPercent)}%</div>
          <div className="col font-bold">{t("energyIndirectEmissions")}</div>
          <div className="col">{NumberUtil.formatWithCommas(emission?.energyIndirectEmissions)}</div>
          <div className="col">{NumberUtil.formatWithCommas(emission?.energyIndirectEmissionsPercent)}%</div>
        </div>
      </>
    );
  };

  const axios_getChartDataByCaseSn = (caseSn = "", planSn = "") => {
    setOopsShow(true);
    checkLoading(loading);
    let reqBody = {};
    if (caseSn !== "") {
      reqBody.caseSn = caseSn;
    }
    if (planSn !== "") {
      reqBody.planSn = planSn;
    }
    getChartDataByCaseSn(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody;
          setSearchCon((pre) => {
            return {
              ...pre,
              companyName: data.companyName,
              placeName: data?.placeName,
              caseSn: {
                placeName: data?.placeName,
                year: data?.year,
                caseSn: data?.caseSn,
                planSn: reqBody?.planSn,
                displayYear: pre?.caseSn?.displayYear,
              },
            };
          });
          setOopsShow(false);
          setSearchDialog(false);
          setValue("companyName", "");
          setValue("caseSn", "");
          let greenhouseGasList = res?.data?.RespBody?.greenhouseGasList;
          setAllFactoryGas(greenhouseGasList?.find((item) => item.type === "A"));
          setGasEmissions(greenhouseGasList?.find((item) => item.type === "B"));
          setEmission(res?.data?.RespBody?.emission);
          setRatingResults(res?.data?.RespBody?.dataGrading);
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  useEffect(() => {
    if (location?.state?.companyName !== undefined) {
      setSearchCon({
        companyName: location?.state?.companyName,
        caseSn: location?.state?.caseSn,
      });
      axios_getChartDataByCaseSn(location?.state?.caseSn?.caseSn, location?.state?.caseSn?.planSn);
    } else {
      if (getCompanyType() === "A") {
        //廠商需要自動顯示第一筆資料
        let caseSnTemp = "";
        let planSnTemp = "";
        if (location?.state?.caseSn) {
          caseSnTemp = location?.state?.caseSn?.caseSn;
        } else {
          caseSnTemp = "";
        }
        if (location?.state?.caseSn?.planSn) {
          planSnTemp = location?.state?.caseSn?.planSn;
        } else {
          planSnTemp = "";
        }
        axios_getChartDataByCaseSn(caseSnTemp, planSnTemp);
      }
    }

    // 組件將要卸載時執行的清除函數
    return () => {
      // 在這裡執行清除資料的操作
    };
  }, [location]);

  useEffect(() => {
    if (allFactoryGas) {
      setAllFactoryGasData(mapGasData(allFactoryGas));
    }
  }, [allFactoryGas]);

  useEffect(() => {
    if (gasEmissions) {
      setGasEmissionsData(mapGasData(gasEmissions));
    }
  }, [gasEmissions]);

  useEffect(() => {
    if (emission) {
      setEmissionsData([
        {
          value: Number(emission?.scope1Percent),
          name: t("category1") /* 範疇1 */,
        },
        {
          value: Number(emission?.energyIndirectEmissionsPercent),
          name: t("category2") /* 範疇2 */,
        },
        { value: Number(emission?.otherIndirectEmissionsPercent), name: t("category3") /* 範疇3 */ },
      ]);
    }
    setEmissionsDataDetail([
      [
        "{title|{b}}{abg|}",
        `{text|${t("fixedEmissions") /* 固定排放*/}：}{percent|${NumberUtil.formatWithCommas(
          emission?.fixEmissionsPercent,
        )}%}`,
        `{text|${t("processEmissions") /* 製程排放 */}：}{percent|${NumberUtil.formatWithCommas(
          emission?.processEmissionsPercent,
        )}%}`,
        `{text|${t("mobileEmissions") /* 移動排放 */}：}{percent|${NumberUtil.formatWithCommas(
          emission?.mobileEmissionsPercent,
        )}%}`,
        `{text|${t("fugitiveEmissions") /* 逸散排放 */}：}{percent|${NumberUtil.formatWithCommas(
          emission?.fugitiveEmissionsPercent,
        )}%}`,
      ],
      [
        "{title|{b}}{abg|}",
        `{text|${t("energyIndirectEmissions") /* 能源間接排放 */}：}{percent|${NumberUtil.formatWithCommas(
          emission?.energyIndirectEmissionsPercent,
        )}%}`,
      ],
      [
        "{title|{b}}{abg|}",
        `{text|${t("otherIndirectEmissions") /* 其他間接排放 */}：}{percent|${NumberUtil.formatWithCommas(
          emission?.otherIndirectEmissionsPercent,
        )}%}`,
      ],
    ]);
  }, [emission]);

  const mapGasData = (gasData) => {
    return [
      { value: Number(gasData?.co2Percent), name: "CO2", unit: "%" },
      { value: Number(gasData?.ch4Percent), name: "CH4", unit: "%" },
      { value: Number(gasData?.n2oPercent), name: "N2O", unit: "%" },
      { value: Number(gasData?.hfcsPercent), name: "HFCS", unit: "%" },
      { value: Number(gasData?.pfcsPercent), name: "PFCS", unit: "%" },
      { value: Number(gasData?.sf6Percent), name: "SF6", unit: "%" },
      { value: Number(gasData?.nf3Percent), name: "NF3", unit: "%" },
    ];
  };

  //   取得第一個區塊資料
  const gasForm = (data) => {
    const gasData = [
      { name: "CO2", emissions: "co2", percent: "co2Percent" },
      { name: "CH4", emissions: "ch4", percent: "ch4Percent" },
      { name: "N2O", emissions: "n2o", percent: "n2oPercent" },
      { name: "HFCs", emissions: "hfcs", percent: "hfcsPercent" },
      { name: "PFCs", emissions: "pfcs", percent: "pfcsPercent" },
      { name: "SF6", emissions: "sf6", percent: "sf6Percent" },
      { name: "NF3", emissions: "nf3", percent: "nf3Percent" },
      { name: t("bioEmissionEquivalent"), emissions: "co2BioEnergy" },
    ];
    return (
      <>
        {/* <div className="p-card-body grid"> */}
        <div className="dashboard-gas-table-wrapper">
          {gasData?.map((gas, index) => (
            <div key={index} className="dashboard-gas-table">
              <div className="dashboard-gas-table-header">{gas?.name}</div>
              <div className="dashboard-gas-table-col font-bold">{t("emissionEquivalent")}</div>
              <div className="dashboard-gas-table-col text-right">
                {NumberUtil.formatWithCommas(data?.[gas?.emissions])}
              </div>
              <div className="dashboard-gas-table-col font-bold">{t("gasProportion")}</div>
              <div className="dashboard-gas-table-col text-right">
                {" "}
                {data?.[gas?.percent] ? `${NumberUtil.formatWithCommas(data[gas.percent])} %` : "-"}
              </div>
            </div>
            // <Card
            // key={index}
            // title={
            //     <div className="header">{gas?.name}</div>
            // }
            // subTitle={
            //     <div className="subTitle">
            //         <div className="grid">{t('emissionEquivalent')}: {data?.[gas?.emissions]}</div>
            //         <div>{t('gasProportion')}: {data?.[gas?.percent]} %</div>
            //     </div>
            // }
            // >
            // </Card>
          ))}
        </div>
        <small>
          {t("dashboardNote")}
          {/* 註：依溫室氣體排放量盤查登錄管理法第二條第一款規定，溫室氣體排放量以公噸二氧化碳當量(公噸CO2e)表示，並四捨五入至小數點後第三位。*/}
        </small>
      </>
    );
  };

  const handleSearchDataReg = () => {
    let state = null;
    if (JSON.stringify(searchCon) !== "{}") {
      state = {
        companyName: searchCon?.companyName,
        caseSn: {
          placeName: searchCon?.caseSn?.placeName,
          year: searchCon?.caseSn?.year,
          caseSn: searchCon?.caseSn?.caseSn,
          displayYear: searchCon?.caseSn?.displayYear,
        },
      };
      navigate("/management/dashboard/dataList", { state });
    } else {
      navigate("/management/dashboard/dataList");
    }
  };

  const getFileName = (fileName) => {
    return (
      location?.state?.caseSn.year +
      "_" +
      location?.state?.caseSn.displayCause +
      "_" +
      location?.state?.companyName +
      "_" +
      location?.state?.caseSn.placeName +
      "_" +
      fileName
    );
  };

  const reactToPrintFn = useReactToPrint({
    documentTitle: getFileName(t("button.dashboard")),
    contentRef,
  });

  const handleDownload = async (ref, fileName = "chart") => {
    if (!ref.current) return;

    const canvas = await html2canvas(ref.current, {
      useCORS: true,
      scale: 2,
    });
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/jpg");
    link.download = fileName + ".jpg";
    link.click();
  };

  const placeNameField = (placeNames) => {
    // 確保 placeNames 永遠是陣列
    const namesArray = Array.isArray(placeNames) ? placeNames : [placeNames];

    if (!namesArray || namesArray.length === 0) return null;

    const showCount = 1; // 超過 1 個收合
    const displayList = expanded ? namesArray : namesArray.slice(0, showCount);
    const remaining = namesArray.length - showCount;

    const displayValue = displayList.join(", ");

    return (
      <span className="inline-flex items-center gap-1">
        <span>{displayValue}</span>
        {remaining > 0 && (
          <Button
            type="button"
            onClick={() => setExpanded(!expanded)}
            className="p-button-text"
            icon={expanded ? "pi pi-angle-up" : "pi pi-angle-down"}
            text
            size="small"
            style={{ height: "1.5rem", width: "0.2rem" }}
          />
        )}
      </span>
    );
  };

  return (
    <>
      {isPlanSn && (
        <div className="flex justify-content-between flex-wrap align-items-center">
          <div className="align-items-start">
            <Button
              rounded
              text
              onClick={() => {
                navigate("/management/carbonFootprint");
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
              {t("button.return_to_list")}
            </Button>
          </div>
          <div className="flex items-center gap-2 align-items-end">
            <span className="text-base">{t("button.dashboard")}</span>
            <Button
              tooltipOptions={{ position: "top" }}
              tooltip={t("button.print")}
              rounded
              text
              severity="secondary"
              className="flex items-center justify-center p-1"
              onClick={reactToPrintFn}
            >
              <FontAwesomeIcon icon="fa-solid fa-print" className="text-base" />
            </Button>
          </div>
        </div>
      )}
      <div ref={contentRef} style={{ maxWidth: "100%", margin: "0px 2px" }}>
        {/* 上方查詢區   */}
        <div className="p-card bg-gray mb-3">
          <div className="p-card-body">
            <div className="grid">
              <div className="col-12 md:col-4">
                <label className="label-has-icon">{t("organName")}</label>
                <span>{searchCon?.companyName}</span>
              </div>

              <div className="col-12 md:col-4">
                <label className="label-has-icon">{t("year")}</label>
                <span>{searchCon?.caseSn?.displayYear || searchCon?.caseSn?.year}</span>
              </div>

              <div className="col-12 md:col-4">
                <label className="label-has-icon">{t("place_name")}</label>
                {placeNameField(searchCon?.placeName)}
              </div>

              {!isPlanSn && (
                <div className="col-12 gap-2">
                  <Button
                    onClick={() => {
                      handleSearchDataReg();
                    }}
                    type="button"
                    label={t("button.requery")}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* oopsShow true的話 <NoInfo> 幫我換成這裡什麼都沒有的圖片 */}
        {oopsShow ? (
          <NoInfo panel="table" />
        ) : (
          <>
            {/* 下方顯示區 */}
            <div className="dashboard-grid">
              {/* 全廠七大溫室氣體排放量 */}
              <div className="p-card" ref={chartRef1}>
                <div className="p-card-body">
                  <div className="p-card-title">
                    <span>{t("dashboard.factory_seven_gas")}</span>
                    {/* <Button outlined type="button" label={'統計圖'} size="small" /> */}
                    <div className="flex items-centerg gap-2">
                      <Button
                        tooltip={t("button.downloadImg")}
                        rounded
                        text
                        icon="pi pi-image"
                        severity="secondary"
                        className="flex items-center justify-center p-1"
                        onClick={() => handleDownload(chartRef1, getFileName(t("dashboard.factory_seven_gas")))}
                      />
                      <ToggleButton
                        className="w-8rem"
                        onLabel={t("SummaryGraph")}
                        offLabel={t("statisticsTable")}
                        onIcon="pi pi-chart-pie"
                        offIcon="pi pi-table"
                        tooltip={t("dashboard.change")}
                        tooltipOptions={{ position: "top" }}
                        checked={factoryGasChecked}
                        onChange={(e) => setFactoryGasChecked(e.value)}
                      />
                    </div>
                  </div>
                  <div className="dashboard-table-wrapper">
                    {!factoryGasChecked ? (
                      <>{allFactoryGas && gasForm(allFactoryGas)}</>
                    ) : (
                      <>
                        {allFactoryGasData?.length !== 0 && allFactoryGas?.length !== 0 && (
                          <CusDountChart
                            tooltipFormatter={{
                              trigger: "item",
                              position: "inside",
                              formatter: (params) => {
                                return `${params.marker} ${params.name}: ${NumberUtil.formatWithCommas(params.value)}%`;
                              },
                            }}
                            donutChartData={allFactoryGasData}
                          ></CusDountChart>
                        )}
                      </>
                    )}
                  </div>
                  {/* 圖表 loading 畫面 */}
                  {allFactoryGas?.length === 0 && factoryGasChecked && <ChartSkeleton model="gas" />}
                </div>
              </div>
              {/* 範疇一七大溫室氣體排放量統計表 */}
              <div className="p-card" ref={chartRef2}>
                <div className="p-card-body">
                  <div className="p-card-title">
                    <span>{t("dashboard.category_1_seven_gas")}</span>
                    {/* <Button outlined type="button" label={'統計圖'} size="small" /> */}
                    <div className="flex items-centerg gap-2">
                      <Button
                        tooltip={t("button.downloadImg")}
                        rounded
                        text
                        icon="pi pi-image"
                        severity="secondary"
                        className="flex items-center justify-center p-1"
                        onClick={() => handleDownload(chartRef2, getFileName(t("dashboard.category_1_seven_gas")))}
                      />
                      <ToggleButton
                        className="w-9rem"
                        onLabel={t("SummaryGraph")}
                        offLabel={t("statisticsTable")}
                        onIcon="pi pi-chart-pie"
                        offIcon="pi pi-table"
                        checked={emissionGasChecked}
                        tooltip={t("dashboard.change")}
                        tooltipOptions={{ position: "top" }}
                        onChange={(e) => {
                          setEmissionGasChecked(e.value);
                        }}
                      />
                    </div>
                  </div>
                  <div className="dashboard-table-wrapper">
                    {!emissionGasChecked ? (
                      <>{gasEmissions && gasForm(gasEmissions)}</>
                    ) : (
                      <>
                        {gasEmissionsData?.length !== 0 && gasEmissions?.length !== 0 && (
                          <CusDountChart
                            tooltipFormatter={{
                              trigger: "item",
                              position: "inside",
                              formatter: (params) => {
                                return `${params.marker} ${params.name}: ${NumberUtil.formatWithCommas(params.value)}%`;
                              },
                            }}
                            donutChartData={gasEmissionsData}
                          ></CusDountChart>
                        )}
                      </>
                    )}
                  </div>
                  {/* 圖表 loading 畫面 */}
                  {gasEmissions?.length === 0 && emissionGasChecked && <ChartSkeleton model="gas" />}
                </div>
              </div>
              {/* 全廠溫室氣體範疇別及範疇一排放型式排放量 */}
              <div className="p-card" ref={chartRef3}>
                <div className="p-card-body">
                  <div className="p-card-title">
                    <span>{t("dashboard.category_1_emission_type_emissions")}</span>
                    {/* <Button outlined type="button" label={'統計圖'} size="small" /> */}
                    <div className="flex items-centerg gap-2">
                      <Button
                        tooltip={t("button.downloadImg")}
                        rounded
                        text
                        icon="pi pi-image"
                        severity="secondary"
                        className="flex items-center justify-center p-1"
                        onClick={() =>
                          handleDownload(chartRef3, getFileName(t("dashboard.category_1_emission_type_emissions")))
                        }
                      />
                      <ToggleButton
                        className="w-9rem"
                        onLabel={t("SummaryGraph")}
                        offLabel={t("statisticsTable")}
                        onIcon="pi pi-chart-pie"
                        offIcon="pi pi-table"
                        tooltip={t("dashboard.change")}
                        tooltipOptions={{ position: "top" }}
                        checked={emissionChecked}
                        onChange={(e) => setEmissionChecked(e.value)}
                      />
                    </div>
                  </div>
                  <div className="dashboard-table-wrapper">
                    {!emissionChecked ? (
                      <>
                        {emission ? (
                          <>
                            <div className="dashboard-table">
                              {/* 第一個區塊 年度總排放量 */}
                              <div className="header">{t("totalAnnualEmissions")}</div>
                              <div className="header right">
                                {NumberUtil.formatWithCommas(emission?.totalAnnualEmissions)}
                              </div>
                              <div className="header right">
                                {NumberUtil.formatWithCommas(emission?.totalAnnualEmissionsPercent).toString() + "%"}
                              </div>
                              {/* 範疇1 */}
                              <div className="col font-bold">{t("category_no", { no: 1 })}</div>
                              <div className="col right">{NumberUtil.formatWithCommas(emission?.scope1)}</div>
                              <div className="col right">{NumberUtil.formatWithCommas(emission?.scope1Percent)}%</div>
                              {/* 範疇2 */}
                              <div className="col font-bold">{t("category_no", { no: 2 })}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.energyIndirectEmissions)}
                              </div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.energyIndirectEmissionsPercent)}%
                              </div>
                              {/* 範疇3 */}
                              <div className="col font-bold">{t("category_no", { no: 3 })}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.otherIndirectEmissions)}
                              </div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.otherIndirectEmissionsPercent)}%
                              </div>
                            </div>

                            {/* 第二個區塊 範疇1 */}
                            <div className="dashboard-table">
                              <div className="header">{t("category_no", { no: 1 })}</div>
                              <div className="header right">{NumberUtil.formatWithCommas(emission?.scope1)}</div>
                              <div className="header right">
                                {NumberUtil.formatWithCommas(emission?.scope1Percent)}%
                              </div>
                              <div className="col font-bold">{t("fixedEmissions")}</div>
                              <div className="col right">{NumberUtil.formatWithCommas(emission?.fixEmissions)}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.fixEmissionsPercent)}%
                              </div>
                              <div className="col font-bold">{t("processEmissions")}</div>
                              <div className="col right">{NumberUtil.formatWithCommas(emission?.processEmissions)}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.processEmissionsPercent)}%
                              </div>
                              <div className="col font-bold">{t("mobileEmissions")}</div>
                              <div className="col right">{NumberUtil.formatWithCommas(emission?.mobileEmissions)}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.mobileEmissionsPercent)}%
                              </div>
                              <div className="col font-bold">{t("fugitiveEmissions")}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.fugitiveEmissions)}
                              </div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.fugitiveEmissionsPercent)}%
                              </div>
                            </div>

                            {/* 第三個區塊 範疇2 */}
                            <div className="dashboard-table">
                              <div className="header">{t("category_no", { no: 2 })}</div>
                              <div className="header right">
                                {NumberUtil.formatWithCommas(emission?.energyIndirectEmissions)}
                              </div>
                              <div className="header right">
                                {NumberUtil.formatWithCommas(emission?.energyIndirectEmissionsPercent)}%
                              </div>
                              <div className="col font-bold">{t("energyIndirectEmissions")}</div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.energyIndirectEmissions)}
                              </div>
                              <div className="col right">
                                {NumberUtil.formatWithCommas(emission?.energyIndirectEmissionsPercent)}%
                              </div>
                            </div>
                          </>
                        ) : (
                          <EmptyEmission />
                        )}
                      </>
                    ) : (
                      <>
                        {emissionsData?.length !== 0 && (
                          <CusDountChart
                            donutChartData={emissionsData}
                            labelShowDetail={true}
                            labelDetail={emissionsDataDetail}
                            // radius={["25%", "50%"]}
                            // width="750px"
                            tooltipFormatter={{
                              trigger: "item",
                              position: "inside",
                              formatter: (params) => {
                                return `${params.marker} ${params.name}: ${NumberUtil.formatWithCommas(params.value)}%`;
                              },
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                  {/* 圖表 loading 畫面 */}
                  {emissionsData?.length === 0 && emissionChecked && <ChartSkeleton model="category" />}
                </div>
              </div>
              {/* 全廠溫室氣體數據等級評分結果 */}
              <div className="p-card" ref={chartRef4}>
                <div className="p-card-body">
                  <div className="p-card-title">
                    <span>{t("dashboard.rating_results")}</span>
                    <div className="flex items-centerg gap-2">
                      <Button
                        tooltip={t("button.downloadImg")}
                        rounded
                        text
                        icon="pi pi-image"
                        severity="secondary"
                        className="flex items-center justify-center p-1"
                        onClick={() => handleDownload(chartRef4, getFileName(t("dashboard.rating_results")))}
                      />
                    </div>
                  </div>
                  <div className="dashboard-table-wrapper">
                    {
                      // ratingResults && (
                      <>
                        <div className="rating-results">
                          <div className="col-6">
                            <p className="title">{t("inventoryOverallAverageScore") /* 清冊總平均分數 */}</p>
                            <p className="score">{NumberUtil.formatWithCommas(ratingResults?.avgScore)}</p>
                          </div>
                          <div className="col-6 text-right">
                            <p className="title">{t("inventoryLevel") /* 清冊級別 */}</p>
                            <span className="score">{NumberUtil.formatWithCommas(ratingResults?.level)}</span>
                            <span className="text">{t("level") /* 級 */}</span>
                          </div>
                        </div>
                        <CusGaugeChart
                          gaugeChartData={[{ value: Number(ratingResults?.avgScore) }]}
                          intervalList={[0.33, 0.66, 1]}
                        />
                      </>

                      // )
                    }
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
